export const includesNumber = (str: string) => {
  return /\d/.test(str);
};
export const includesSpecialCharacter = (str: string) => {
  return /\W/.test(str);
};
